import { render, staticRenderFns } from "./TagEditor.vue?vue&type=template&id=46f69817&scoped=true"
import script from "./TagEditor.vue?vue&type=script&lang=js"
export * from "./TagEditor.vue?vue&type=script&lang=js"
import style0 from "./TagEditor.vue?vue&type=style&index=0&id=46f69817&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f69817",
  null
  
)

export default component.exports